import { render, staticRenderFns } from "./QueuesStatisticsResume.vue?vue&type=template&id=12f73c44"
import script from "./QueuesStatisticsResume.vue?vue&type=script&lang=ts"
export * from "./QueuesStatisticsResume.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports